
import companyLogo from "branch/resource/company-logo.png"

export const printHeader = ({ jsPDFDoc, companyData, startX, startY}) => {
 
  let xPos = startX
  let yPos = startY

  const logoWidth = 1.5
  const logoHeight = 1.5
  const lineHeight = 0.2
  const img = new Image()
  const defaultHeaderSize = 22;
  const comapanyAddrSize = 12;
  img.src = companyLogo
  try {
    jsPDFDoc.addImage(img, 'png', xPos, yPos- 0.35 , logoWidth, logoHeight)
   
    xPos += logoWidth + 0.1
  } catch (e) {
   
  }
  jsPDFDoc.setFont("THSarabun", "bold")
  jsPDFDoc.setFontSize(defaultHeaderSize)
  yPos += 0.2
  jsPDFDoc.text(companyData.NameTH, xPos, yPos)
  jsPDFDoc.setFont("THSarabun", "normal")
  jsPDFDoc.setFontSize(comapanyAddrSize)
  yPos += lineHeight
  const addrs = jsPDFDoc.splitTextToSize(companyData.AddrTH, 4)
  for(const addr of addrs){
    jsPDFDoc.text(addr, xPos, yPos)
    yPos += lineHeight - 0.025
  }
  jsPDFDoc.text(`Tax ID: ${companyData.TaxId}`, xPos, yPos)
  yPos += lineHeight - 0.025
  jsPDFDoc.text(`Tel: ${companyData.Tel}${companyData.Fax && ` Fax: ${companyData.Fax}`}`, xPos, yPos)
  return yPos
}